import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APINewsletter {

  getUrlDomain(nome_metodo)
  {

    let result = "";

    if (location.hostname == "localhost") {
        result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = "https://companysupport.eu/";

    }

    return result + nome_metodo;


  }


  async registerNewsletter(url_portale, email)
  {

    let formData = new FormData();

    formData.append("url_portale",  url_portale);
    formData.append("email",  email);
    
    return axios.post(this.getUrlDomain("CareersRegisterNewsletter") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }

  async unregisterNewsletter(url_portale, email)
  {

    let formData = new FormData();

    formData.append("url_portale",  url_portale);
    formData.append("email",  email);
    
    return axios.post(this.getUrlDomain("CareersUnregisterNewsletter") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }

  async deleteNewsletter(id)
  {

    let formData = new FormData();

    formData.append("v_id",  id);
    
    return axios.post(this.getUrlDomain("CareersDelNewsletter") , formData ,{ 'Content-Type': 'multipart/form-data' }   ) ;

  }



}

export default new APINewsletter({
  url: "https://services.ebadge.it/public/api/"
})
